import { AppProvider } from './provider';
import { AppRouter } from './router';

const App = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
App.displayName = 'App';

export { App };
